import { action } from "satcheljs";

const restOpenShiftsStore = action(
    "RESET_OPEN_SHIFTS_STORE",
    () => ({})
);

export default restOpenShiftsStore;